import { getJson, postJson } from 'utils/http';

import { ApiNotification } from './types/notifications/ApiNotification';

export const fetchNotifications = (): Promise<Array<ApiNotification>> =>
  // @ts-expect-error TS(2345): Argument of type '({ notifications }: { notificati... Remove this comment to see the full error message
  getJson('/data/notifications').then(({ notifications }) => notifications);

export const dismissNotifications = (notificationIds: Array<string>) =>
  postJson('/data/notifications-read', {
    notificationIds,
    // @ts-expect-error TS(2345): Argument of type '({ notifications }: { notificati... Remove this comment to see the full error message
  }).then(({ notifications }) => notifications);
